import {
  Companion_getInstance139kwuiq3xn4y as Companion_getInstance,
  OtpSecret2919vqlwy0it0 as OtpSecret,
} from './AuthSecrets.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { OtpHashAlgorithm1ycw1mfra8exn as OtpHashAlgorithm } from './OtpHashAlgorithm.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareOtpSecretFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [OtpSecret__id_getInstance(), OtpSecret_subjectType_getInstance(), OtpSecret_subjectId_getInstance(), OtpSecret_label_getInstance(), OtpSecret_secretBase32_getInstance(), OtpSecret_issuer_getInstance(), OtpSecret_period_getInstance(), OtpSecret_digits_getInstance(), OtpSecret_algorithm_getInstance(), OtpSecret_establishedAt_getInstance(), OtpSecret_lastUsedAt_getInstance(), OtpSecret_expiresAt_getInstance(), OtpSecret_disabledAt_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function OtpSecret__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function OtpSecret__id$_get_name_$ref_qf2qw3() {
  return (p0) => p0.k20();
}
function OtpSecret__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret__id$_get_serializer_$ref_u7w70q() {
  return (p0) => p0.j2j();
}
function OtpSecret__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function OtpSecret__id$_get_annotations_$ref_thyegi() {
  return (p0) => p0.bz();
}
var OtpSecret__idClass;
function OtpSecret__id() {
  if (OtpSecret__idClass === VOID) {
    class $ {
      constructor() {
        OtpSecret__id_instance = this;
        var tmp = this;
        tmp.j2r_1 = lazy(OtpSecret__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k2r_1 = lazy(OtpSecret__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l2r_1 = lazy(OtpSecret__id$annotations$delegate$lambda);
        this.m2r_1 = Companion_getInstance_0().m2p();
        this.n2r_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.j2r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret__id$_get_name_$ref_qf2qw3(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.p2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      c2s(receiver, value) {
        return receiver.d2s(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.c2s(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k2r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret__id$_get_serializer_$ref_u7w70q(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l2r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret__id$_get_annotations_$ref_thyegi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret__id', VOID, VOID, [SerializableProperty()]);
    OtpSecret__idClass = $;
  }
  return OtpSecret__idClass;
}
var OtpSecret__id_instance;
function OtpSecret__id_getInstance() {
  if (OtpSecret__id_instance === VOID)
    new (OtpSecret__id())();
  return OtpSecret__id_instance;
}
function OtpSecret_subjectType$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function OtpSecret_subjectType$_get_name_$ref_7brfgx() {
  return (p0) => p0.k20();
}
function OtpSecret_subjectType$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_subjectType$_get_serializer_$ref_2snh2() {
  return (p0) => p0.j2j();
}
function OtpSecret_subjectType$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function OtpSecret_subjectType$_get_annotations_$ref_iida7a() {
  return (p0) => p0.bz();
}
var OtpSecret_subjectTypeClass;
function OtpSecret_subjectType() {
  if (OtpSecret_subjectTypeClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_subjectType_instance = this;
        var tmp = this;
        tmp.e2s_1 = lazy(OtpSecret_subjectType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f2s_1 = lazy(OtpSecret_subjectType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g2s_1 = lazy(OtpSecret_subjectType$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.e2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_subjectType$_get_name_$ref_7brfgx(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.q2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      h2s(receiver, value) {
        return receiver.d2s(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.h2s(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_subjectType$_get_serializer_$ref_2snh2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_subjectType$_get_annotations_$ref_iida7a(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_subjectType', VOID, VOID, [SerializableProperty()]);
    OtpSecret_subjectTypeClass = $;
  }
  return OtpSecret_subjectTypeClass;
}
var OtpSecret_subjectType_instance;
function OtpSecret_subjectType_getInstance() {
  if (OtpSecret_subjectType_instance === VOID)
    new (OtpSecret_subjectType())();
  return OtpSecret_subjectType_instance;
}
function OtpSecret_subjectId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function OtpSecret_subjectId$_get_name_$ref_ue8ftc() {
  return (p0) => p0.k20();
}
function OtpSecret_subjectId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_subjectId$_get_serializer_$ref_tozz87() {
  return (p0) => p0.j2j();
}
function OtpSecret_subjectId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function OtpSecret_subjectId$_get_annotations_$ref_d87ow5() {
  return (p0) => p0.bz();
}
var OtpSecret_subjectIdClass;
function OtpSecret_subjectId() {
  if (OtpSecret_subjectIdClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_subjectId_instance = this;
        var tmp = this;
        tmp.i2s_1 = lazy(OtpSecret_subjectId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j2s_1 = lazy(OtpSecret_subjectId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k2s_1 = lazy(OtpSecret_subjectId$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.i2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_subjectId$_get_name_$ref_ue8ftc(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.r2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      h2s(receiver, value) {
        return receiver.d2s(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.h2s(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_subjectId$_get_serializer_$ref_tozz87(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_subjectId$_get_annotations_$ref_d87ow5(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_subjectId', VOID, VOID, [SerializableProperty()]);
    OtpSecret_subjectIdClass = $;
  }
  return OtpSecret_subjectIdClass;
}
var OtpSecret_subjectId_instance;
function OtpSecret_subjectId_getInstance() {
  if (OtpSecret_subjectId_instance === VOID)
    new (OtpSecret_subjectId())();
  return OtpSecret_subjectId_instance;
}
function OtpSecret_label$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function OtpSecret_label$_get_name_$ref_11cie5() {
  return (p0) => p0.k20();
}
function OtpSecret_label$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_label$_get_serializer_$ref_24z6gs() {
  return (p0) => p0.j2j();
}
function OtpSecret_label$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function OtpSecret_label$_get_annotations_$ref_kuik1k() {
  return (p0) => p0.bz();
}
var OtpSecret_labelClass;
function OtpSecret_label() {
  if (OtpSecret_labelClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_label_instance = this;
        var tmp = this;
        tmp.l2s_1 = lazy(OtpSecret_label$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m2s_1 = lazy(OtpSecret_label$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n2s_1 = lazy(OtpSecret_label$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.l2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_label$_get_name_$ref_11cie5(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.s2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      h2s(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.h2s(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_label$_get_serializer_$ref_24z6gs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_label$_get_annotations_$ref_kuik1k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_label', VOID, VOID, [SerializableProperty()]);
    OtpSecret_labelClass = $;
  }
  return OtpSecret_labelClass;
}
var OtpSecret_label_instance;
function OtpSecret_label_getInstance() {
  if (OtpSecret_label_instance === VOID)
    new (OtpSecret_label())();
  return OtpSecret_label_instance;
}
function OtpSecret_secretBase32$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function OtpSecret_secretBase32$_get_name_$ref_5ofw35() {
  return (p0) => p0.k20();
}
function OtpSecret_secretBase32$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_secretBase32$_get_serializer_$ref_33v4pk() {
  return (p0) => p0.j2j();
}
function OtpSecret_secretBase32$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function OtpSecret_secretBase32$_get_annotations_$ref_tmpzfg() {
  return (p0) => p0.bz();
}
var OtpSecret_secretBase32Class;
function OtpSecret_secretBase32() {
  if (OtpSecret_secretBase32Class === VOID) {
    class $ {
      constructor() {
        OtpSecret_secretBase32_instance = this;
        var tmp = this;
        tmp.o2s_1 = lazy(OtpSecret_secretBase32$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p2s_1 = lazy(OtpSecret_secretBase32$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q2s_1 = lazy(OtpSecret_secretBase32$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.o2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_secretBase32$_get_name_$ref_5ofw35(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.t2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      h2s(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.h2s(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_secretBase32$_get_serializer_$ref_33v4pk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_secretBase32$_get_annotations_$ref_tmpzfg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_secretBase32', VOID, VOID, [SerializableProperty()]);
    OtpSecret_secretBase32Class = $;
  }
  return OtpSecret_secretBase32Class;
}
var OtpSecret_secretBase32_instance;
function OtpSecret_secretBase32_getInstance() {
  if (OtpSecret_secretBase32_instance === VOID)
    new (OtpSecret_secretBase32())();
  return OtpSecret_secretBase32_instance;
}
function OtpSecret_issuer$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function OtpSecret_issuer$_get_name_$ref_3g9jue() {
  return (p0) => p0.k20();
}
function OtpSecret_issuer$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_issuer$_get_serializer_$ref_vspvdb() {
  return (p0) => p0.j2j();
}
function OtpSecret_issuer$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function OtpSecret_issuer$_get_annotations_$ref_osztpn() {
  return (p0) => p0.bz();
}
var OtpSecret_issuerClass;
function OtpSecret_issuer() {
  if (OtpSecret_issuerClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_issuer_instance = this;
        var tmp = this;
        tmp.r2s_1 = lazy(OtpSecret_issuer$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s2s_1 = lazy(OtpSecret_issuer$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t2s_1 = lazy(OtpSecret_issuer$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_issuer$_get_name_$ref_3g9jue(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.u2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      h2s(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.h2s(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_issuer$_get_serializer_$ref_vspvdb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_issuer$_get_annotations_$ref_osztpn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_issuer', VOID, VOID, [SerializableProperty()]);
    OtpSecret_issuerClass = $;
  }
  return OtpSecret_issuerClass;
}
var OtpSecret_issuer_instance;
function OtpSecret_issuer_getInstance() {
  if (OtpSecret_issuer_instance === VOID)
    new (OtpSecret_issuer())();
  return OtpSecret_issuer_instance;
}
function OtpSecret_period$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function OtpSecret_period$_get_name_$ref_xvcor6() {
  return (p0) => p0.k20();
}
function OtpSecret_period$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_period$_get_serializer_$ref_8yl69z() {
  return (p0) => p0.j2j();
}
function OtpSecret_period$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function OtpSecret_period$_get_annotations_$ref_mfwvtv() {
  return (p0) => p0.bz();
}
var OtpSecret_periodClass;
function OtpSecret_period() {
  if (OtpSecret_periodClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_period_instance = this;
        var tmp = this;
        tmp.u2s_1 = lazy(OtpSecret_period$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v2s_1 = lazy(OtpSecret_period$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w2s_1 = lazy(OtpSecret_period$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_period$_get_name_$ref_xvcor6(), null);
        return tmp0.f2();
      }
      x2s(receiver) {
        return receiver.v2r_1;
      }
      m2j(receiver) {
        return new (Duration())(this.x2s(receiver instanceof OtpSecret() ? receiver : THROW_CCE()));
      }
      y2s(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.y2s(tmp, value instanceof Duration() ? value.nj_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_period$_get_serializer_$ref_8yl69z(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_period$_get_annotations_$ref_mfwvtv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_period', VOID, VOID, [SerializableProperty()]);
    OtpSecret_periodClass = $;
  }
  return OtpSecret_periodClass;
}
var OtpSecret_period_instance;
function OtpSecret_period_getInstance() {
  if (OtpSecret_period_instance === VOID)
    new (OtpSecret_period())();
  return OtpSecret_period_instance;
}
function OtpSecret_digits$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function OtpSecret_digits$_get_name_$ref_z0a7mf() {
  return (p0) => p0.k20();
}
function OtpSecret_digits$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_digits$_get_serializer_$ref_8hurcy() {
  return (p0) => p0.j2j();
}
function OtpSecret_digits$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function OtpSecret_digits$_get_annotations_$ref_y6gbpe() {
  return (p0) => p0.bz();
}
var OtpSecret_digitsClass;
function OtpSecret_digits() {
  if (OtpSecret_digitsClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_digits_instance = this;
        var tmp = this;
        tmp.z2s_1 = lazy(OtpSecret_digits$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a2t_1 = lazy(OtpSecret_digits$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b2t_1 = lazy(OtpSecret_digits$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.z2s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_digits$_get_name_$ref_z0a7mf(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.w2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      c2t(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.c2t(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_digits$_get_serializer_$ref_8hurcy(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_digits$_get_annotations_$ref_y6gbpe(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_digits', VOID, VOID, [SerializableProperty()]);
    OtpSecret_digitsClass = $;
  }
  return OtpSecret_digitsClass;
}
var OtpSecret_digits_instance;
function OtpSecret_digits_getInstance() {
  if (OtpSecret_digits_instance === VOID)
    new (OtpSecret_digits())();
  return OtpSecret_digits_instance;
}
function OtpSecret_algorithm$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function OtpSecret_algorithm$_get_name_$ref_i3aia0() {
  return (p0) => p0.k20();
}
function OtpSecret_algorithm$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_algorithm$_get_serializer_$ref_dfqp7j() {
  return (p0) => p0.j2j();
}
function OtpSecret_algorithm$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function OtpSecret_algorithm$_get_annotations_$ref_6h0g59() {
  return (p0) => p0.bz();
}
var OtpSecret_algorithmClass;
function OtpSecret_algorithm() {
  if (OtpSecret_algorithmClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_algorithm_instance = this;
        var tmp = this;
        tmp.d2t_1 = lazy(OtpSecret_algorithm$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e2t_1 = lazy(OtpSecret_algorithm$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f2t_1 = lazy(OtpSecret_algorithm$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.d2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_algorithm$_get_name_$ref_i3aia0(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.x2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      g2t(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.g2t(tmp, value instanceof OtpHashAlgorithm() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_algorithm$_get_serializer_$ref_dfqp7j(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_algorithm$_get_annotations_$ref_6h0g59(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_algorithm', VOID, VOID, [SerializableProperty()]);
    OtpSecret_algorithmClass = $;
  }
  return OtpSecret_algorithmClass;
}
var OtpSecret_algorithm_instance;
function OtpSecret_algorithm_getInstance() {
  if (OtpSecret_algorithm_instance === VOID)
    new (OtpSecret_algorithm())();
  return OtpSecret_algorithm_instance;
}
function OtpSecret_establishedAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function OtpSecret_establishedAt$_get_name_$ref_jltlv8() {
  return (p0) => p0.k20();
}
function OtpSecret_establishedAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_establishedAt$_get_serializer_$ref_q2v3dx() {
  return (p0) => p0.j2j();
}
function OtpSecret_establishedAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function OtpSecret_establishedAt$_get_annotations_$ref_b0u8qn() {
  return (p0) => p0.bz();
}
var OtpSecret_establishedAtClass;
function OtpSecret_establishedAt() {
  if (OtpSecret_establishedAtClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_establishedAt_instance = this;
        var tmp = this;
        tmp.h2t_1 = lazy(OtpSecret_establishedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i2t_1 = lazy(OtpSecret_establishedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j2t_1 = lazy(OtpSecret_establishedAt$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.k2t_1 = get_default(Companion_instance).d1m();
        this.l2t_1 = 'now()';
      }
      k20() {
        var tmp0 = this.h2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_establishedAt$_get_name_$ref_jltlv8(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.y2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      m2t(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.m2t(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_establishedAt$_get_serializer_$ref_q2v3dx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_establishedAt$_get_annotations_$ref_b0u8qn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_establishedAt', VOID, VOID, [SerializableProperty()]);
    OtpSecret_establishedAtClass = $;
  }
  return OtpSecret_establishedAtClass;
}
var OtpSecret_establishedAt_instance;
function OtpSecret_establishedAt_getInstance() {
  if (OtpSecret_establishedAt_instance === VOID)
    new (OtpSecret_establishedAt())();
  return OtpSecret_establishedAt_instance;
}
function OtpSecret_lastUsedAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function OtpSecret_lastUsedAt$_get_name_$ref_8wu88n() {
  return (p0) => p0.k20();
}
function OtpSecret_lastUsedAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_lastUsedAt$_get_serializer_$ref_s5zboi() {
  return (p0) => p0.j2j();
}
function OtpSecret_lastUsedAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function OtpSecret_lastUsedAt$_get_annotations_$ref_4odbvm() {
  return (p0) => p0.bz();
}
var OtpSecret_lastUsedAtClass;
function OtpSecret_lastUsedAt() {
  if (OtpSecret_lastUsedAtClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_lastUsedAt_instance = this;
        var tmp = this;
        tmp.n2t_1 = lazy(OtpSecret_lastUsedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o2t_1 = lazy(OtpSecret_lastUsedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p2t_1 = lazy(OtpSecret_lastUsedAt$annotations$delegate$lambda);
        this.q2t_1 = null;
        this.r2t_1 = 'null';
      }
      k20() {
        var tmp0 = this.n2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_lastUsedAt$_get_name_$ref_8wu88n(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.z2r_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      s2t(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.s2t(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_lastUsedAt$_get_serializer_$ref_s5zboi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_lastUsedAt$_get_annotations_$ref_4odbvm(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_lastUsedAt', VOID, VOID, [SerializableProperty()]);
    OtpSecret_lastUsedAtClass = $;
  }
  return OtpSecret_lastUsedAtClass;
}
var OtpSecret_lastUsedAt_instance;
function OtpSecret_lastUsedAt_getInstance() {
  if (OtpSecret_lastUsedAt_instance === VOID)
    new (OtpSecret_lastUsedAt())();
  return OtpSecret_lastUsedAt_instance;
}
function OtpSecret_expiresAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(11);
}
function OtpSecret_expiresAt$_get_name_$ref_5glbk() {
  return (p0) => p0.k20();
}
function OtpSecret_expiresAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_expiresAt$_get_serializer_$ref_enfirt() {
  return (p0) => p0.j2j();
}
function OtpSecret_expiresAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(11);
}
function OtpSecret_expiresAt$_get_annotations_$ref_bvzrkr() {
  return (p0) => p0.bz();
}
var OtpSecret_expiresAtClass;
function OtpSecret_expiresAt() {
  if (OtpSecret_expiresAtClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_expiresAt_instance = this;
        var tmp = this;
        tmp.t2t_1 = lazy(OtpSecret_expiresAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u2t_1 = lazy(OtpSecret_expiresAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v2t_1 = lazy(OtpSecret_expiresAt$annotations$delegate$lambda);
        this.w2t_1 = null;
        this.x2t_1 = 'null';
      }
      k20() {
        var tmp0 = this.t2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_expiresAt$_get_name_$ref_5glbk(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.a2s_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      s2t(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.s2t(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_expiresAt$_get_serializer_$ref_enfirt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_expiresAt$_get_annotations_$ref_bvzrkr(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_expiresAt', VOID, VOID, [SerializableProperty()]);
    OtpSecret_expiresAtClass = $;
  }
  return OtpSecret_expiresAtClass;
}
var OtpSecret_expiresAt_instance;
function OtpSecret_expiresAt_getInstance() {
  if (OtpSecret_expiresAt_instance === VOID)
    new (OtpSecret_expiresAt())();
  return OtpSecret_expiresAt_instance;
}
function OtpSecret_disabledAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(12);
}
function OtpSecret_disabledAt$_get_name_$ref_47gug0() {
  return (p0) => p0.k20();
}
function OtpSecret_disabledAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function OtpSecret_disabledAt$_get_serializer_$ref_hoc5dz() {
  return (p0) => p0.j2j();
}
function OtpSecret_disabledAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(12);
}
function OtpSecret_disabledAt$_get_annotations_$ref_46qq97() {
  return (p0) => p0.bz();
}
var OtpSecret_disabledAtClass;
function OtpSecret_disabledAt() {
  if (OtpSecret_disabledAtClass === VOID) {
    class $ {
      constructor() {
        OtpSecret_disabledAt_instance = this;
        var tmp = this;
        tmp.y2t_1 = lazy(OtpSecret_disabledAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z2t_1 = lazy(OtpSecret_disabledAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a2u_1 = lazy(OtpSecret_disabledAt$annotations$delegate$lambda);
        this.b2u_1 = null;
        this.c2u_1 = 'null';
      }
      k20() {
        var tmp0 = this.y2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, OtpSecret_disabledAt$_get_name_$ref_47gug0(), null);
        return tmp0.f2();
      }
      o2r(receiver) {
        return receiver.b2s_1;
      }
      m2j(receiver) {
        return this.o2r(receiver instanceof OtpSecret() ? receiver : THROW_CCE());
      }
      s2t(receiver, value) {
        return receiver.d2s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof OtpSecret() ? receiver : THROW_CCE();
        return this.s2t(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z2t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, OtpSecret_disabledAt$_get_serializer_$ref_hoc5dz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a2u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, OtpSecret_disabledAt$_get_annotations_$ref_46qq97(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'OtpSecret_disabledAt', VOID, VOID, [SerializableProperty()]);
    OtpSecret_disabledAtClass = $;
  }
  return OtpSecret_disabledAtClass;
}
var OtpSecret_disabledAt_instance;
function OtpSecret_disabledAt_getInstance() {
  if (OtpSecret_disabledAt_instance === VOID)
    new (OtpSecret_disabledAt())();
  return OtpSecret_disabledAt_instance;
}
//region block: exports
export {
  prepareOtpSecretFields as prepareOtpSecretFields1uppd2f3lkgqy,
};
//endregion

//# sourceMappingURL=OtpSecretFields.mjs.map
